<template>
  <div class="banner">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in bannerArr" :key="index">
        <img style="width: 100%" :src="item.path" alt="" />
      </swiper-slide>
    </swiper>
    <div
      class="swiper-button-prev swiper-button-prevsp"
      slot="button-prev"
    ></div>
    <div
      class="swiper-button-next swiper-button-nextsp"
      slot="button-next"
    ></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      bannerArr: [],
      swiperOptions: {
        loop: true,
        speed: 1000,
        slidesPerView: 1,
        slideToClickedSlide: true,
        autoplay: true,
        // autoplay: {
        // delay: 3000,
        // stopOnLastSlide: false,
        // disableOnInteraction: false,
        // },
        // 显示分页
        pagination: {
          el: ".banner .swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        on: {
          click(res) {
            console.log(res, "res");
          },
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".banner .swiper-button-next",
          prevEl: ".banner .swiper-button-prev",
        },
        // 修改默认点击左右箭头样式
        // navigation: {
        // nextEl: ".swiper-button-next",
        //prevEl: ".swiper-button-prev",
        //},
      },
    };
  },
  methods: {
    getBannerData() {
      this.$request("/media/getLbt", "GET", {
        type: "01",
        sybh: 1,
      }).then((res) => {
        this.bannerArr = res.data.data;
      });
    },
  },
  mounted() {
    this.getBannerData();
  },
};
</script>  
<style lang="less" scoped>
.banner {
  position: relative;
  .swiper-button-next,
  .swiper-button-prev {
    width: 72px;
    height: 72px;
    background-size: 72px 72px;
    margin-top: 0;
    transform: translateY(-50%);
  }
  .swiper-button-prev:after,
  .swiper-button-next:after {
    content: "";
  }
  .swiper-button-prev {
    left: 60px;
    background-image: url(~@/assets/images/home-swiper-prev.png);
  }

  .swiper-button-next {
    right: 60px;
    background-image: url(~@/assets/images/home-swiper-next.png);
  }
}
</style>